export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarNavList.vue?vue&type=template&id=3bc4c8e4&"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/SidebarNavList.vue?vue&type=template&id=3bc4c8e4&
// module id = null
// module chunks = 